import React, { HTMLAttributes, forwardRef } from 'react';
import { useStyles } from './styles';
import { cx } from '../customEmotion';
import { ColorProp } from '../types/color';
import { Theme } from '../styles';

type TypographyElement =
	| HTMLHeadingElement
	| HTMLParagraphElement
	| HTMLDivElement;

export interface TypographyProps extends Omit<HTMLAttributes<TypographyElement>, 'color'> {
	className?: string;
	/**
	 * The component used for the root node. Either a string to use a DOM element or a component.
	 */
	variant: keyof Theme['typography']['fontSize'];
	color?: ColorProp;
	/**
	 * If not passed, it will be `400`.
	 */
	weight?: keyof Theme['typography']['fontWeight'];
	/**
	 * If `true`, there will be a bottom margin.
	 */
	gutterBottom?: boolean;
	/**
	 * If `true`, the text will not wrap, but instead will truncate with an ellipsis.
	 */
	noWrap?: boolean;
	align?: 'C' | 'R' | '';
}

const Typography = forwardRef<TypographyElement, TypographyProps>((
	{
		children,
		className,
		variant: Vari,
		color,
		weight,
		gutterBottom,
		noWrap,
		align,
		...props
	},
	ref
) => {
	const styles = useStyles([Vari, color, weight, gutterBottom, noWrap, align]);

	return (
		<Vari
			{...props}
			className={className ? cx(styles.typography, className) : styles.typography}
			ref={ref}
		>
			{children}
		</Vari>
	);
});

Typography.defaultProps = {
	weight: 'normal',
	gutterBottom: false,
	noWrap: false,
};

export default Typography;
